import script from "./KurucularScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./KurucularScreen.vue?vue&type=script&setup=true&lang=js"

import "./KurucularScreen.vue?vue&type=style&index=0&id=781fa53e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-781fa53e"]])

export default __exports__